<template>
  <div class="app-sign-up-modal" :class="{ open: isOpen }">
    <div v-down-outside="close" class="modal auth-modal sign-up">
      <div class="close-btn" @click="close">
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
        >
          <g>
            <g>
              <path
                d="M505.943,6.058c-8.077-8.077-21.172-8.077-29.249,0L6.058,476.693c-8.077,8.077-8.077,21.172,0,29.249
              C10.096,509.982,15.39,512,20.683,512c5.293,0,10.586-2.019,14.625-6.059L505.943,35.306
              C514.019,27.23,514.019,14.135,505.943,6.058z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M505.942,476.694L35.306,6.059c-8.076-8.077-21.172-8.077-29.248,0c-8.077,8.076-8.077,21.171,0,29.248l470.636,470.636
              c4.038,4.039,9.332,6.058,14.625,6.058c5.293,0,10.587-2.019,14.624-6.057C514.018,497.866,514.018,484.771,505.942,476.694z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="header">Join dropp.me with</div>
      <div class="social-container">
        <div class="social-btn google">
          <img src="./../../assets/images/social-google.svg" alt="" />
          <span>Log In with Google</span>
        </div>
      </div>
      <div class="or-container">
        <div class="bar"></div>
        <div class="or-text">or</div>
        <div class="bar"></div>
      </div>
      <div class="input-container">
        <Input class="input" placeholder="Email" />
        <!-- <Input class="input" placeholder="Password" type="password"/> -->
      </div>

      <div class="submit or-btn">
        Join with Email
      </div>
      <div class="switch">
        <div class="account-exist">
          Already a member?<span @click="openSignIn">Log in</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { downOutside } from 'app/utils/directives/down-outside';

import { ModalEvents } from 'app/utils/events';
import Input from 'app/components/common/Input.vue';

export default {
  name: 'SignUpModal',

  components: {
    Input,
  },
  directives: {
    downOutside,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapGetters([]),
  },
  mounted() {
    ModalEvents.addListener('signup:open', this.open);
    ModalEvents.addListener('signup:close', this.close);
  },
  destroyed() {
    ModalEvents.removeListener('signup:open', this.open);
    ModalEvents.removeListener('signup:close', this.close);
  },
  methods: {
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    openSignIn() {
      this.close();
      ModalEvents.emit('signin:open');
    },
  },
};
</script>

<style lang="scss" scoped>
.app-sign-up-modal {
  display: none;
  background-color: rgba(0, 0, 0, 0.7);
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
  position: fixed;
  align-items: center;
  justify-content: center;

  &.open {
    display: flex;
  }

  .submit {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    height: 48px;
  }

  .bottom-content {
    padding-top: 20px;
    display: flex;
    justify-content: center;
  }
}
</style>
